import React from 'react';
import AssetList from '../../components/assetcomponents/AssetList';

function Assets() {

    return (
        <>
            {/*Dynamic content goes here */}
            <AssetList />
        </>
    )
};


export default Assets;